import type { ITrustpilotRating, ITrustpilotRatingModel } from '../types/trustpilotRating'

export const TrustpilotRatingFromJSON = (json: ITrustpilotRating): ITrustpilotRatingModel => {
	const { ratings_count, ...rest } = json
	return { ...rest, ratingsCount: ratings_count }
}

export const TrustpilotRatingToJSON = (obj: Partial<ITrustpilotRatingModel>): Partial<ITrustpilotRating> => {
	const { ratingsCount, ...rest } = obj
	return { ...rest, ratings_count: ratingsCount }
}
